import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { AuthProvider } from "react-oidc-context";
import { BrowserRouter } from "react-router-dom";
import { store } from "redux/store/store";
import CacheBuster from "./CacheBuster";
import App from "./App";
import { authConfig } from "shared/constants";
import * as serviceWorker from "./serviceWorker";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import "semantic-ui-css/semantic.min.css";
import "./index.module.scss";
import "locales/i18n";

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <Provider store={store}>
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
        if (loading) return null;
        if (!loading && !isLatestVersion) {
          refreshCacheAndReload();
        }

        return (
          isLatestVersion && (
            <BrowserRouter>
              <AuthProvider {...authConfig}>
                <App />
              </AuthProvider>
            </BrowserRouter>
          )
        );
      }}
    </CacheBuster>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
